import { render, staticRenderFns } from "./ClientFormInput.vue?vue&type=template&id=1cbc8820&scoped=true"
import script from "./ClientFormInput.vue?vue&type=script&lang=js"
export * from "./ClientFormInput.vue?vue&type=script&lang=js"
import style0 from "./ClientFormInput.vue?vue&type=style&index=0&id=1cbc8820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbc8820",
  null
  
)

export default component.exports